export enum MimeType {
  JPG = 'image/jpg',
  PNG = 'image/png',
  JPEG = 'image/jpeg',
  ZIP = 'application/zip',
  PDF = 'application/pdf',
  MicrosoftWordOpenXML = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  DCM = 'application/dicom',
  // extend if needed
}

export const mimeTypeForString = (mimeTypeString: Nullable<string>) => {
  if (!mimeTypeString || !Object.values(MimeType).includes(mimeTypeString as MimeType)) {
    return undefined;
  }

  return mimeTypeString as MimeType;
};
